import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Adaptador de fecha personalizado para formato DD/MM/YYYY
 * Parsea correctamente el formato día/mes/año (europeo/argentino)
 */
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (!value || typeof value !== 'string') {
      return null;
    }

    const trimmed = value.trim();

    // Detectar formato DDMMYY (6 dígitos sin separadores)
    if (/^\d{6}$/.test(trimmed)) {
      const day = parseInt(trimmed.substring(0, 2), 10);
      const month = parseInt(trimmed.substring(2, 4), 10) - 1; // Los meses en JS son 0-indexados
      const yy = parseInt(trimmed.substring(4, 6), 10);
      const year = 2000 + yy; // Asumir 20XX

      // Validar que sean números válidos
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        const date = new Date(year, month, day);
        // Verificar que la fecha sea válida
        if (date.getFullYear() === year && 
            date.getMonth() === month && 
            date.getDate() === day) {
          return date;
        }
      }
    }

    // Detectar formato DDMMYYYY (8 dígitos sin separadores)
    if (/^\d{8}$/.test(trimmed)) {
      const day = parseInt(trimmed.substring(0, 2), 10);
      const month = parseInt(trimmed.substring(2, 4), 10) - 1; // Los meses en JS son 0-indexados
      const year = parseInt(trimmed.substring(4, 8), 10);

      // Validar que sean números válidos
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        const date = new Date(year, month, day);
        // Verificar que la fecha sea válida
        if (date.getFullYear() === year && 
            date.getMonth() === month && 
            date.getDate() === day) {
          return date;
        }
      }
    }

    // Detectar formato DD/MM/YYYY o D/M/YYYY
    const parts = trimmed.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Los meses en JS son 0-indexados
      const year = parseInt(parts[2], 10);

      // Validar que sean números válidos
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        const date = new Date(year, month, day);
        // Verificar que la fecha sea válida
        if (date.getFullYear() === year && 
            date.getMonth() === month && 
            date.getDate() === day) {
          return date;
        }
      }
    }

    return null;
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
